var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 3.5L13.449 4.88197H14.9021L13.7265 5.73607L14.1756 7.11803L13 6.26393L11.8244 7.11803L12.2735 5.73607L11.0979 4.88197H12.551L13 3.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 9.5L10.2245 10.191H10.9511L10.3633 10.618L10.5878 11.309L10 10.882L9.41221 11.309L9.63673 10.618L9.04894 10.191H9.77549L10 9.5Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.93325 2.23804C5.42447 1.01745 7.4248 0.499494 9.50002 0.5L11.1506 0.500403L9.77726 1.41602C9.68926 1.47469 9.59867 1.53419 9.50604 1.59504C8.78424 2.06916 7.93819 2.6249 7.22568 3.50289C6.43718 4.4745 5.7999 5.86327 5.7999 8.00259C5.7999 10.1419 6.43716 11.5292 7.2255 12.4996C7.93621 13.3743 8.77956 13.9284 9.50047 14.402C9.59508 14.4641 9.68758 14.5249 9.7774 14.5848L11.1502 15.5007H9.4999C7.42506 15.5007 5.42478 14.984 3.9335 13.7647C2.42612 12.5323 1.5 10.6316 1.5 8.00259C1.5 5.37364 2.42605 3.47172 3.93325 2.23804ZM4.56665 3.01187C3.32389 4.02909 2.5 5.62895 2.5 8.00259C2.5 10.3762 3.32388 11.9746 4.56647 12.9905C5.41613 13.6852 6.48951 14.1302 7.68953 14.346C7.2701 14.0105 6.84116 13.6124 6.44937 13.1301C5.51268 11.9772 4.7999 10.3659 4.7999 8.00259C4.7999 5.63932 5.51266 4.02679 6.44919 2.87275C6.84136 2.38951 7.27068 1.99063 7.69049 1.65451C6.4902 1.87051 5.41653 2.31622 4.56665 3.01187Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.a19350a4.svg";
export { ForwardRef as ReactComponent };